// api/adgroup.js
import request from './request'

export const adgroupApi = {
    // 获取广告组列表
    getList(params) {
        return request({
            url: '/adgroup/list',
            method: 'get',
            withCredentials: false,
            params
        })
    },

    // 创建广告组
    create(data) {
        return request({
            url: '/adgroup/create',
            method: 'post',
            withCredentials: false,
            data
        })
    },

    // 更新广告组
    update(data) {
        return request({
            url: '/adgroup/update',
            method: 'post',
            data
        })
    },

    // 更新状态
    updateStatus(data) {
        return request({
            url: '/adgroup/status/update',
            method: 'post',
            data
        })
    },

    // 更新预算
    updateBudget(data) {
        return request({
            url: '/adgroup/budget/update',
            method: 'post',
            data
        })
    }
}